import './styles.scss';
import { Text } from '@fragments';
import { IconStack2, IconUsers, IconHelpCircle } from '@tabler/icons-react';

export default function TemplateCard({ template, onClick }) {
    const totalQuestions = template.formData.steps.reduce(
        (sum, s) => sum + (s.questions?.length ?? 0), 0,
    );

    return (
        <div
            className="template-card"
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onClick()}
        >
            <div className="tc-banner" style={{ background: template.banner }}>
                <div className="tc-banner-overlay" />
                <div className="tc-banner-content">
                    <Text.h5 className="tc-title">{template.title}</Text.h5>
                </div>
            </div>

            <div className="tc-body">
                <Text.span contrast={6} className="tc-description">{template.description}</Text.span>

                <div className="tc-stats">
                    <div className="tc-stat">
                        <IconStack2 size={13} />
                        <Text.span contrast={4}>
                            {template.stepsCount} etapa{template.stepsCount !== 1 ? 's' : ''}
                        </Text.span>
                    </div>
                    <span className="tc-stat-dot" />
                    <div className="tc-stat">
                        <IconHelpCircle size={13} />
                        <Text.span contrast={4}>{totalQuestions} pergunta{totalQuestions !== 1 ? 's' : ''}</Text.span>
                    </div>
                    <span className="tc-stat-dot" />
                    <div className="tc-stat">
                        <IconUsers size={13} />
                        <Text.span contrast={4}>{template.indicatedFor}</Text.span>
                    </div>
                </div>

                <div className="tc-chips">
                    {template.questionsSummary.map((label, i) => (
                        <span key={i} className="tc-chip">{label}</span>
                    ))}
                </div>
            </div>
        </div>
    );
}
